import { eventChannel, END } from 'redux-saga';
import { call, put, take, delay } from 'redux-saga/effects';
import { actions } from './reducer';
import type { EventChannel } from 'redux-saga';
import { Observable } from 'rxjs';

export const RECONNECT_TIMEOUT = 6000;

export function websocketInitChannel(connection: WebSocket): EventChannel<any> {
  return eventChannel(emitter => {
    const closeCallback = () => {
      // console.log('connection closed!');
      emitter(actions.connectionLost());
      return emitter(END);
    };

    connection.onmessage = e => {
      // handle default response from keep alive ping
      if (e.data === 'Not Found') {
        return;
      }
      return emitter(actions.storeReceivedMessage(JSON.parse(e.data)));
    };

    connection.onclose = closeCallback;
    connection.onerror = closeCallback;

    return () => {
      // unsubscribe function
      connection.close();
    };
  });
}

export function* sendMessage(connection: WebSocket) {
  while (true) {
    const { payload } = yield take(actions.send);
    yield put(actions.storeSentMessage(payload));
    yield call([connection, connection.send], JSON.stringify(payload));
  }
}

export function* handleWebsocketKeepAlive(_action: any) {
  try {
    while (true) {
      yield delay(1000 * 60 * 9.5); // 9 and a half minutes. The timeout for for API Gateway WS is 10 minutes.
      yield put(
        actions.send({
          action: 'keepAlive'
        })
      );
    }
  } catch (e) {
    console.log('failed to keep alive websocket conection');
  }
}

export function subscriptionChannel(obs: Observable<unknown>, subscriptionHandlerAction: any): EventChannel<any> {
  return eventChannel(emitter => {
    const closeCallback = () => {
      return emitter(END);
    };
    const subscription = obs.subscribe(data => {
      return emitter(subscriptionHandlerAction(data));
    });

    return () => {
      subscription.unsubscribe();
      closeCallback();
    };
  });
}
